/* ============================================================
   Shop the Feed — autoplay-in-view (videos always muted).
   - Plays each card's video only while it's in the viewport
     (saves battery/bandwidth, especially on mobile).
   - Videos are always muted (no sound control) so autoplay is
     allowed by browsers.
   Self-contained, no dependencies. Safe to load once per page.
   ============================================================ */
(function () {
  function initFeed(root) {
    var videos = root.querySelectorAll('.stf__video');
    if (!videos.length) return;

    // Fade the poster out the moment the video is actually rendering frames,
    // so the card never shows a blank box mid-scroll.
    videos.forEach(function (v) {
      var media = v.closest('.stf__media');
      if (!media) return;
      var reveal = function () { media.classList.add('is-playing'); };
      v.addEventListener('playing', reveal);
      // Some browsers fire only 'timeupdate' once decoding starts.
      v.addEventListener('timeupdate', function () { if (v.currentTime > 0) reveal(); });
    });

    // Play when visible, pause when not. `rootMargin` starts buffering before
    // the card is centered so playback is ready by the time it's on screen.
    // Falls back to "just play" if IntersectionObserver is unavailable.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 300px 0px 300px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    }

    // Videos are always muted (no sound control) — the <video> keeps `muted`.

    // Shop the Look: open each card's drawer from its pill.
    root.querySelectorAll('.stf__look[data-stf-drawer]').forEach(function (btn) {
      // Resolve the drawer once, now — after the first open it gets portaled
      // to <body>, so re-querying the card would return null on later clicks.
      var card = btn.closest('.stf__card');
      var drawer = card && card.querySelector('.stf__drawer');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (drawer) openDrawer(drawer);
      });
    });
    root.querySelectorAll('.stf__drawer').forEach(function (drawer) {
      // Close on backdrop click (but not when clicking inside the panel).
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer(drawer);
      });
      var closeBtn = drawer.querySelector('.stf__drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer(drawer); });
    });

    // Add-to-cart inside the drawer is a real merme product form
    // ([data-merme-add-form]); the global assets/merme-cart-add.js handles the
    // submit (AJAX add + opens the cart drawer). No interception needed here —
    // the drawer-row anchor still navigates to the product page on tap.
  }

  function openDrawer(d) {
    // The drawer markup lives inside .stf__card, which is `overflow:hidden`
    // and sits inside the horizontally-scrolling .stf__track. That traps the
    // drawer's stacking context and clips it, so on mobile the bottom sheet
    // got hidden behind later cards/sections. Portal it to <body> on first
    // open so its `position:fixed; inset:0; z-index:1000` is relative to the
    // viewport with nothing above it. (Idempotent — no-op once moved.)
    if (d.parentElement !== document.body) document.body.appendChild(d);
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('stf-drawer-open');
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('stf-drawer-open');
  }
  // ESC closes whichever drawer is open.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.stf__drawer.is-open');
      if (open) closeDrawer(open);
    }
  });

  function boot() {
    document.querySelectorAll('.stf').forEach(initFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a merchant adds/edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.stf') : null;
    if (el) initFeed(el);
  });
})();
